"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
// UI
var gameScore = document.querySelector(".game-score");
var highScore = document.querySelector(".high-score");
// Button
var startBtn = document.querySelector(".start");
var restartBtn = document.querySelector(".restart");
// Message
var winMessage = document.querySelector(".message-win");
var loseMessage = document.querySelector(".message-lose");
var startMessage = document.querySelector(".message-start");
// Game fields
var isGameHas2048 = false;
var score = 0;
var rows = 4;
var columns = 4;
var cell = _to_consumable_array(document.querySelectorAll(".field-cell"));
var board;
var scoreFromLocalStorage = localStorage.getItem("highScore");
// Game logic
window.onload = function() {
    if (scoreFromLocalStorage) highScore.textContent = scoreFromLocalStorage;
    else highScore.textContent = 0;
};
startBtn.addEventListener("click", function() {
    setGame();
    startMessage.classList.add("hidden");
    loseMessage.classList.add("hidden");
    restartBtn.classList.remove("hidden");
    startBtn.classList.add("hidden");
});
restartBtn.addEventListener("click", function() {
    winMessage.classList.add("hidden");
    loseMessage.classList.add("hidden");
    if (score > scoreFromLocalStorage) {
        highScore.textContent = score;
        localStorage.setItem("highScore", score);
    }
    score = 0;
    gameScore.textContent = score;
    setGame();
});
var setGame = function() {
    board = [
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ]
    ];
    for(var r = 0; r < rows; r++)for(var c = 0; c < columns; c++){
        var num = board[r][c];
        var cellIndex = r * columns + c;
        var cellElement = cell[cellIndex];
        updateCell(cellElement, num);
    }
    setTwoOrFour();
    setTwoOrFour();
};
var updateCell = function(cellElement, num) {
    cellElement.textContent = "";
    cellElement.classList.value = "";
    cellElement.classList.add("field-cell");
    if (num > 0) {
        cellElement.textContent = num.toString();
        if (num < 2048) cellElement.classList.add("field-cell--".concat(num.toString()));
    }
    if (num === 2048) {
        isGameHas2048 = true;
        winMessage.classList.remove("hidden");
    }
};
document.addEventListener("keyup", function(e) {
    if (e.code === "ArrowLeft") {
        if (slideLeft()) setTwoOrFour();
    } else if (e.code === "ArrowRight") {
        if (slideRigth()) setTwoOrFour();
    } else if (e.code === "ArrowUp") {
        if (slideUp()) setTwoOrFour();
    } else if (e.code === "ArrowDown") {
        if (slideDown()) setTwoOrFour();
    }
});
var filterZero = function(rowArr) {
    return rowArr.filter(function(num) {
        return num !== 0;
    });
};
var slide = function(rowArr) {
    var newArr = filterZero(rowArr);
    for(var i = 0; i < newArr.length - 1; i++)if (newArr[i] === newArr[i + 1]) {
        newArr[i] *= 2;
        newArr[i + 1] = 0;
        score += newArr[i];
        gameScore.textContent = score;
    }
    newArr = filterZero(newArr);
    while(newArr.length < 4)newArr.push(0);
    return newArr;
};
var slideLeft = function() {
    var isChange = false;
    for(var r = 0; r < rows; r++){
        var row = board[r];
        var newRow = slide(row);
        if (!isArrayEqual(row, newRow)) isChange = true;
        board[r] = newRow;
        for(var c = 0; c < columns; c++){
            var num = board[r][c];
            var cellIndex = r * columns + c;
            var cellElement = cell[cellIndex];
            updateCell(cellElement, num);
        }
    }
    return isChange;
};
var slideRigth = function() {
    var isChange = false;
    for(var r = 0; r < rows; r++){
        var row = board[r];
        var originalArr = _to_consumable_array(row);
        var rowReverse = row.reverse();
        var newRow = slide(rowReverse);
        var newRowReverse = newRow.slice().reverse();
        if (!isArrayEqual(originalArr, newRowReverse)) isChange = true;
        board[r] = newRowReverse;
        for(var c = 0; c < columns; c++){
            var num = board[r][c];
            var cellIndex = r * columns + c;
            var cellElement = cell[cellIndex];
            updateCell(cellElement, num);
        }
    }
    return isChange;
};
var slideUp = function() {
    var isChange = false;
    for(var c = 0; c < columns; c++){
        var row = [
            board[0][c],
            board[1][c],
            board[2][c],
            board[3][c]
        ];
        var newRow = slide(row);
        if (!isArrayEqual(row, newRow)) isChange = true;
        for(var r = 0; r < rows; r++){
            board[r][c] = newRow[r];
            var num = board[r][c];
            var cellIndex = r * columns + c;
            var cellElement = cell[cellIndex];
            updateCell(cellElement, num);
        }
    }
    return isChange;
};
var slideDown = function() {
    var isChange = false;
    for(var c = 0; c < columns; c++){
        var row = [
            board[0][c],
            board[1][c],
            board[2][c],
            board[3][c]
        ];
        var originalRow = _to_consumable_array(row);
        var rowReverse = row.reverse();
        var newRow = slide(rowReverse);
        var newRowReverse = newRow.slice().reverse();
        if (!isArrayEqual(originalRow, newRowReverse)) isChange = true;
        for(var r = 0; r < rows; r++){
            board[r][c] = newRowReverse[r];
            var num = board[r][c];
            var cellIndex = r * columns + c;
            var cellElement = cell[cellIndex];
            updateCell(cellElement, num);
        }
    }
    return isChange;
};
var isArrayEqual = function(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for(var i = 0; i < arr1.length; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
};
var randomTile = function() {
    return Math.random() > 0.9 ? 4 : 2;
};
var isEmptyTile = function() {
    for(var r = 0; r < rows; r++)for(var c = 0; c < columns; c++){
        if (board[r][c] === 0) return true;
    }
    return false;
};
var checkHorizontalGameOver = function() {
    for(var r = 0; r < rows; r++)for(var c = 0; c < columns - 1; c++){
        if (board[r][c] === board[r][c + 1]) return false;
    }
    return true;
};
var checkVerticalGameOver = function() {
    for(var r = 0; r < rows - 1; r++)for(var c = 0; c < columns; c++){
        if (board[r][c] === board[r + 1][c]) return false;
    }
    return true;
};
var isGameOver = function() {
    if (isEmptyTile()) return false;
    return checkHorizontalGameOver() && checkVerticalGameOver();
};
var setTwoOrFour = function() {
    if (!isEmptyTile()) return;
    var found = false;
    while(!found && !isGameHas2048){
        var r = Math.floor(Math.random() * rows);
        var c = Math.floor(Math.random() * columns);
        if (board[r][c] === 0) {
            board[r][c] = randomTile();
            var cellIndex = r * columns + c;
            var cellElement = cell[cellIndex];
            updateCell(cellElement, board[r][c]);
            found = true;
        }
        if (board[r][c] === 2048) isGameHas2048 = true;
        if (isGameOver()) {
            loseMessage.classList.remove("hidden");
            if (score > highScore.value) {
                highScore.textContent = score;
                localStorage.setItem("highScore", score);
            }
        }
    }
};

//# sourceMappingURL=index.98257aba.js.map
